export function initTabsTextSlider() {
    for (const wrapper of document.querySelectorAll('.tabsTextSectionWrapper')) {
        const tabs = wrapper.querySelectorAll('.tabsTextSection__tab');
        const sections = wrapper.querySelectorAll('.tabsTextSection');

        if (!tabs.length || !sections.length) continue;

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const count = tab.dataset.count;

                tabs.forEach(t => t.classList.toggle('tabsTextSection__tab--active', t === tab));
                sections.forEach(s => s.classList.toggle('tabsTextSection--active', s.dataset.count === count));

                tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            });
        });
    }
}
